import { render, staticRenderFns } from "./AddStudentAfterSales.vue?vue&type=template&id=c2e2e9ba&scoped=true&"
import script from "./AddStudentAfterSales.vue?vue&type=script&lang=js&"
export * from "./AddStudentAfterSales.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentAfterSales.vue?vue&type=style&index=0&id=c2e2e9ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e2e9ba",
  null
  
)

export default component.exports